import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PageLoader } from '@/components/page-loader';
import { useTask } from '@/hooks/use-task-queries';
import { AlertCircle } from 'lucide-react';

export const Route = createFileRoute('/dashboard/task/$taskId')({
  component: TaskDetailLayout,
});

function TaskDetailLayout() {
  const { taskId } = Route.useParams();
  const { data: task, isLoading, isError, error } = useTask(taskId);

  if (isLoading) {
    return <PageLoader />;
  }

  if (isError || !task) {
    return (
      <div className="flex flex-col items-center justify-center py-20 bg-destructive/5 rounded-2xl border border-destructive/10">
        <AlertCircle className="h-12 w-12 text-destructive mb-4" />
        <p className="text-lg font-bold text-destructive">Task not found</p>
        <p className="text-sm text-destructive/60 mt-1">
          {isError && error instanceof Error
            ? error.message
            : 'The requested task could not be located.'}
        </p>
      </div>
    );
  }

  return <Outlet />;
}
